import { Environment } from "../environment.type";

export const cmsURLS = {
  production: process.env.VIRTUAL_DOMAIN,
  preview: process.env.VIRTUAL_DOMAIN,
  localhost: "https://cms.uat.britishcarauctions.net/",
};

const getCMSDomain = (environment: Environment): string => cmsURLS[environment];

export default getCMSDomain;
